/** @format */
import {
    Button,
    ButtonVariant,
} from '@mpb-com/feather/components/atoms/button';
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { Trans, useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { productConditionEnumToText } from '@toucan/client/global/product';

import { styles } from './product-condition-description-modal.styles';
import { ProductConditionDescriptionModalProps } from './types';

export const DEFAULT_TEST_ID = 'product-condition-description';

const StyledProductConditionDescriptionModal = styled.div`
    ${styles}
`;

export const ProductConditionDescriptionModal: FunctionComponent<
    ProductConditionDescriptionModalProps
> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    onClose,
    condition,
    conditionDescription,
    ...otherProps
}) => {
    const { t } = useTranslation();

    const conditionRating = productConditionEnumToText(t, condition);

    return (
        <StyledProductConditionDescriptionModal
            {...otherProps}
            data-testid={dataTestId}
        >
            <div className="product-condition-description-content">
                <Heading size={HeadingSize.H2}>
                    {t('Cosmetic condition')}
                </Heading>
                <p data-testid={`${dataTestId}__overview`}>
                    {t(
                        "We always photograph each item individually, so you’ll get this exact item. Our specialists assess the cosmetic condition from 'like new' to 'heavily used'."
                    )}
                </p>
                <p data-testid={`${dataTestId}__condition`}>
                    <Trans components={[<strong key={0}>$1</strong>]}>
                        {t(
                            'This item is <0>{{conditionRating}}</0>, which generally means:',
                            { conditionRating }
                        )}
                    </Trans>
                </p>
                <p data-testid={`${dataTestId}__description`}>
                    {conditionDescription}
                </p>
            </div>
            <Button
                data-testid={`${dataTestId}__close-button`}
                onClick={onClose}
                variant={ButtonVariant.SECONDARY}
            >
                {t('Got it')}
            </Button>
        </StyledProductConditionDescriptionModal>
    );
};
